import { DATE_RANGES, type DateRangeKey } from "../utils/dateRange";

interface Props {
  value: DateRangeKey;
  onChange: (range: DateRangeKey) => void;
}

export default function DateRangeSelector({ value, onChange }: Props) {
  return (
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
      {DATE_RANGES.map((r) => (
        <button
          key={r}
          onClick={() => onChange(r)}
          style={{
            padding: "3px 10px",
            borderRadius: 4,
            border: `1px solid ${value === r ? "#3b82f6" : "#cbd5e1"}`,
            background: value === r ? "#3b82f6" : "transparent",
            color: value === r ? "#fff" : "#64748b",
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 600,
            transition: "all 0.15s",
          }}
        >
          {r}
        </button>
      ))}
    </div>
  );
}
